// extracted by mini-css-extract-plugin
export default {"div":"feedback_div__J5Ez8"};